<template>
  <div class="main_edit_home">
    <div class="main_header">
        <h1 style="font-size:30px;text-align: center;width: 100%;margin: 0 auto;padding: 0;background: #0072ff;line-height: 70px;color: white;">
            修改用户信息
        </h1>
    </div>
    <a-spin tip="加载中..." 
    style="width:100%;text-align:center;margin-top:20px;margin-bottom:20px;" 
    :spinning="loading">
    </a-spin>
    <div class="main_user_edit_content" :style="{'display':loading?'none':'block'}">
        <ul style="display:grid;margin:0;padding:0;">
            <li style="width:100%;height:70px;">
                <a-input addon-before="账号" ref="userOrigPasswordInput" placeholder="请输入账号" v-model="user.username" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;">
                <a-input addon-before="邮箱" type="email" ref="userOrigPasswordInput" placeholder="请输入邮箱" v-model="user.email" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;">
                <a-input-password @focus="passwordFocus" addon-before="密码" ref="userOrigPasswordInput" v-model="password" placeholder="请输入新密码, 留空表示不修改密码" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input-password>
            </li>
            <li style="width:100%;height:70px;">
                <a-input addon-before="昵称" ref="userOrigPasswordInput" placeholder="请输入昵称" v-model="user.nickname" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="margin-top:20px;">
                <span style="text-align:left;width:100%;height:40px;display:block;">
                    头像
                </span>
                <FileUpload v-bind:argument="avatarArgument" @fileChange="fileChange"></FileUpload>
            </li>
            <li style="width:100%;height:70px;">
                <a-input addon-before="真实姓名" ref="userOrigPasswordInput" placeholder="请输入真实姓名" v-model="user.name" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;">
                <a-input addon-before="联系电话" ref="userOrigPasswordInput" placeholder="请输入联系电话" v-model="user.mobile" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="margin-top:20px;" v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier') && user.inspector.identifier">
                <span style="text-align:left;width:100%;height:40px;display:block;">
                    鉴定资格证
                </span>
                <FileUpload v-bind:argument="appraisalCertificateArgument" @fileChange="fileChange"></FileUpload>
            </li>
            <li style="margin-top:20px;" v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier') && user.inspector.identifier">
                <span style="text-align:left;width:100%;height:40px;display:block;">
                    签名
                </span>
                <el-image fit="cover"  
                v-if="!sign_edit && user && user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('sign') && user.inspector.sign.hasOwnProperty('image_url') && user.inspector.sign.image_url" :src="user.inspector.sign.image_url"
                :style="{'width':String(signature_width)+'px', 'height':String(signature_height)+'px'}"
                >
                </el-image>
                <vue-signature 
                v-if="sign_edit || sign_empty"
                ref='signature'
                :width="signature_width"
                :height="signature_height"
                />
                <a-button @click="sign_edit=!sign_edit" v-if="sign_edit && !sign_empty" type="Primary" style="margin-top:20px;">
                    关闭签名
                </a-button>
                <a-button @click="sign_edit=!sign_edit" v-if="!sign_edit && !sign_empty" type="Primary" style="margin-top:20px;">
                    打开签名
                </a-button>
                <a-button v-else type="Primary" style="margin-top:20px;margin-left:20px;" :style="{'margin-left':!sign_empty?'20px':'0px'}" @click="signature_clear">
                    清空签名
                </a-button>
            </li>
            
            <li style="margin-top:40px;">
                <span v-if="user.wx_user && user.wx_user.identifier" style="float:left;text-align:left;width:60px;line-height:40px;display:block;">
                    微信用户
                </span>
                <span v-else style="float:left;text-align:left;width:60px;line-height:30px;display:block;">
                    微信绑定
                </span>
                <a-button @click="wechat_login_action" style="float:left;background:#30D469;height:30px;color:white;font-size:16px;margin-left:20px;" v-if="user && (!user.wx_user || !user.wx_user.hasOwnProperty('identifier') || !user.wx_user.identifier) && isWeChatBrowser()" type="Primary">点击微信授权绑定</a-button>
                
                <wxlogin
                    v-if="user && (!user.wx_user || !user.wx_user.hasOwnProperty('identifier') || !user.wx_user.identifier) && !isWeChatBrowser()"
                    :appid="app_id"
                    :scope="'snsapi_login'"
                    :theme="'black'"
                    style="margin-left:0;padding-left:0;"
                    :redirect_uri="encodeURIComponent(urls.wechat.redirect_bind)"
                    :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgew0KICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogIGJvcmRlcjogbm9uZTsNCiAgd2lkdGg6IDIwMHB4Ow0KICBoZWlnaHQ6IDIwMHB4Ow0KfQ0KLmltcG93ZXJCb3ggLnN0YXR1c3sNCiAgZGlzcGxheTogbm9uZQ0KfQ=='"
                >
                </wxlogin>
                
                <el-image fit="cover"  v-if="user.wx_user && user.wx_user.identifier" style="margin-left:10px;float:left;border-radius:50%;width:40px;height:40px;" :src="user.wx_user.head_img_url">
                </el-image>
                <span v-if="user.wx_user && user.wx_user.identifier" style="float:left;margin-left:10px;line-height:40px;display:block;">
                    {{ user.wx_user.nickname }}
                </span>
                <a-button @click="wechat_unbind_action" style="float:right;background:#30D469;height:30px;color:white;font-size:16px;margin-top:5px;" v-if="user.wx_user && user.wx_user.identifier && isWeChatBrowser()" type="Primary">点击微信授权解绑</a-button>
            </li>
            <li style="margin-top:40px;" v-if="user.wx_user && user.wx_user.identifier && !isWeChatBrowser()">
                <span style="width:100%;float:right;height:30px;line-height:30px;font-size:16px;">扫描二维码解除绑定</span>
                <wxlogin
                    :appid="app_id"
                    :scope="'snsapi_login'"
                    :theme="'black'"
                    style="margin-left:0;padding-left:0;"
                    :redirect_uri="encodeURIComponent(urls.wechat.redirect_unbind)"
                    :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgew0KICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogIGJvcmRlcjogbm9uZTsNCiAgd2lkdGg6IDIwMHB4Ow0KICBoZWlnaHQ6IDIwMHB4Ow0KfQ0KLmltcG93ZXJCb3ggLnN0YXR1c3sNCiAgZGlzcGxheTogbm9uZQ0KfQ=='"
                >
                </wxlogin>
            </li>
            <li style="width:100%;height:70px;margin-top:20px;">
                <a-button @click="commit_changes()" :loading="commit_loading" style="border-radius:5px;background:#1890ff;display:block;width:100%;height:50px;line-height:50px;margin-top:20px;color:white;font-size:20px;text-align:center;">
                    完成修改
                </a-button>
            </li>
        </ul>
    </div>
    <a-modal
        title="扫描二维码进行解绑"
        :visible="unbind_modal_visible"
        :confirm-loading="confirm_loading"
        @ok="handleUnbind"
        @cancel="handleBindModalCancel"
        ok-text="提交" 
        cancel-text="取消"
        >
        <wxlogin
            v-if="user && (!user.wx_user || !user.wx_user.hasOwnProperty('identifier') || !user.wx_user.identifier) && !isWeChatBrowser()"
            :appid="app_id"
            :scope="'snsapi_login'"
            :theme="'black'"
            style="margin-left:0;padding-left:0;"
            :redirect_uri="encodeURIComponent(urls.wechat.redirect_unbind)"
            :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsNCiAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5zdGF0dXMuc3RhdHVzX2Jyb3dzZXIgew0KICBkaXNwbGF5OiBub25lOw0KfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogIGJvcmRlcjogbm9uZTsNCiAgd2lkdGg6IDIwMHB4Ow0KICBoZWlnaHQ6IDIwMHB4Ow0KfQ0KLmltcG93ZXJCb3ggLnN0YXR1c3sNCiAgZGlzcGxheTogbm9uZQ0KfQ=='"
        >
        </wxlogin>
    </a-modal>
    <a-modal
        title="请输入原密码进行验证"
        :visible="original_password_visible"
        :confirm-loading="original_password_confirm_loading"
        @ok="handleOriginalPassword"
        @cancel="handleOriginalPasswordCancel"
        ok-text="提交" 
        cancel-text="取消"
        >
        <a-input-group compact>
            <a-input-password style="float:left;" default-value="" v-model="unbind_password" placeholder="请输入密码" />
        </a-input-group>
    </a-modal>
    <div style="width:100%;height:70px;margin-top:50px;text-align:center">
        <span style="line-height:70px;text-align:center">
            {{ company.copyright_no }} 版权所有
        </span>
        <a style="text-align: center;width:100%;line-height: 20px;height:20px;display:block;" href="https://beian.miit.gov.cn" target="_blank">{{ company.record_no }}</a>
    </div>
  </div>
</template>

<script>

import request from '../../api/request'
import userModel from "../../model/user"
import FileUpload from '../upload/FileUpload.vue'
import company_model from '../../model/company'

import urls from "../../api/urls"
import wxlogin from 'vue-wxlogin'
import watermark from 'watermark-dom'

export default {
    name: 'UserEdit',
    head: {
        title: "更新用户信息",
        meta:[
            { name: 'description', content: '更新用户信息'}
        ]
    },
    data: function() {
        return {
            unbind_modal_visible:false,
            confirm_loading:false,
            user: userModel,
            app_id: "wx808d2d7ab225e375",
            mp_app_id: "wx41b9160ff3e6e4aa",
            urls:urls,
            avatarArgument: {
                id: 0,
                click_name: "点击上传",
                key: "avatar",
                accept: ".png, .jpg, .jpeg, .gif, .bmp",
                max_file_count: 1,
                unlimit_count: false,
                fileList: [],
            },
            appraisalCertificateArgument: {
                id: 1,
                click_name: "点击上传",
                key: "appraisal_certificate",
                accept: ".png, .jpg, .jpeg, .gif, .bmp",
                max_file_count: 2,
                unlimit_count: false,
                fileList: [],
            },
            password: "",
            commit_loading: false,
            unbind_password:"",
            original_password: "",
            company: company_model,
            original_password_visible: false,
            original_password_confirm_loading: false,
            signature_width: 500,
            signature_height: 300,
            sign_edit: false,
            sign_empty: true,
            loading: false,
        }
    },
    methods: {
        signature_clear() {
            console.log(this.$refs.signature.getSignature())
            this.$refs.signature.clear()
        },
        handleOriginalPassword() {

        },
        handleOriginalPasswordCancel() {

        },
        passwordFocus() {
            console.log("password focus")
        },
        wechat_login_action() {
            request.site_user.wx_login(this.mp_app_id, urls.wechat.mp_redirect_bind)
        },
        wechat_unbind_action() {
            request.site_user.wx_login(this.mp_app_id, urls.wechat.mp_redirect_unbind)
        },
        isWeChatBrowser() {
            var ua = window.navigator.userAgent.toLowerCase()
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true
            }
            else {
                return false
            }
        },
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        handleUnbind() {
            if (!this.unbind_password) {
                this.$message.error("请输入密码")
                return
            }
            this.confirm_loading = true
            var unbind_resp = request.site_user.unbind(this.unbind_password)
            unbind_resp.then((response) => {
                this.confirm_loading = false
                var failed_message = "解除绑定失败"
                var success_message = "解除绑定成功"
                if (response.status == 200 && response.data.code == 0) {
                    if (response && response.data && response.data.message) {
                        success_message = response.data.message
                    }
                    this.$message.success(success_message)
                    this.fetch_user_info()
                    this.unbind_modal_visible = false
                }
                else {
                    if (response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.confirm_loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
            
            
        },
        handleBindModalCancel() {
            this.unbind_modal_visible = false
            this.unbind_password = ""
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.signature_width = document.body.clientWidth * 0.9
            this.signature_height = 0.7*this.signature_width
            this.fetch_company()
            this.fetch_user_info()
            
        },
        fetch_user_info() {
            this.loading = true
            var user_info_resp = request.site_user.userinfo()
            user_info_resp.then((response) => {
                this.loading = false
                var failed_message = "获取用户信息失败"
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.user = response.data.data
                        if (this.user.thumb_url) {
                            var avatar = {
                                uid: '0',
                                name: 'avatar.png',
                                status: 'done',
                                url:this.user.thumb_url,
                            }
                            this.avatarArgument.fileList.push(avatar)
                            this.$forceUpdate()
                        }
                        if (this.user.inspector && this.user.inspector.appraisal_certificates && this.user.inspector.appraisal_certificates.length > 0) {
                            var appraisal_certificate = {}
                            var appraisal_certificate_image = {}
                            for (var index=0;index<this.user.inspector.appraisal_certificates.length;index++) {
                                appraisal_certificate = this.user.inspector.appraisal_certificates[index]

                                appraisal_certificate_image = {
                                    uid: String(index),
                                    name: 'appraisal_certificate_image_' + String(index) +'.png',
                                    status: 'done',
                                    url:appraisal_certificate.image_url,
                                }
                                this.appraisalCertificateArgument.fileList.push(appraisal_certificate_image)
                            }
                            this.$forceUpdate()
                        }
                        this.sign_empty = !this.user || !this.user.inspector || !this.user.inspector.sign || !this.user.inspector.sign.image_url
                    }
                }
                else {
                    if (response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        commit_changes() {

            var avatar = undefined;
            if (this.avatarArgument.fileList.length > 0) {
                avatar = this.avatarArgument.fileList[0]
            }
            this.commit_loading = true
            var commit_changes_resp = request.site_user.update(this.user.date_of_birth, this.user.email, this.user.mobile, this.user.username, this.user.nickname, this.user.name, this.user.sex, this.user.age, avatar, this.password, this.$refs.signature?this.$refs.signature.getSignature():undefined,this.appraisalCertificateArgument.fileList)
            commit_changes_resp.then((response) => {
                this.commit_loading = false
                var failed_message = "更新用户信息失败"
                var success_message = "更新用户信息成功"
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.message) {
                        success_message = response.data.message
                    }
                    if (response.data && response.data.data) {
                        this.user = response.data.data
                        if (this.user.thumb_url) {
                            var avatarDict = {
                                uid: '0',
                                name: 'avatar.png',
                                status: 'done',
                                url:this.user.thumb_url,
                            }
                            this.avatarArgument.fileList = []
                            this.avatarArgument.fileList.push(avatarDict)
                            this.$forceUpdate()
                        }
                        if (this.user.inspector && this.user.inspector.appraisal_certificates && this.user.inspector.appraisal_certificates.length > 0) {
                            var appraisal_certificate = {}
                            var appraisal_certificate_image = {}
                            this.appraisalCertificateArgument.fileList = []
                            for (var index=0;index<this.user.inspector.appraisal_certificates.length;index++) {
                                appraisal_certificate = this.user.inspector.appraisal_certificates[index]
                                appraisal_certificate_image = {
                                    uid: String(index),
                                    name: 'appraisal_certificate' + String(index) + '.png',
                                    status: 'done',
                                    url:appraisal_certificate.image_url,
                                }
                                console.log(appraisal_certificate_image)
                                this.appraisalCertificateArgument.fileList.push(appraisal_certificate_image)
                            }
                            this.$forceUpdate()
                        }
                    }
                    this.$message.success(success_message)
                    this.$router.push({
                        name: 'OrderList',
                    });
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message);
                }
            })
            .catch((error) => {
                this.commit_loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        fileChange() {
            console.log()
        }
    },
    created() {
        this.load()
    },
    components: {
        FileUpload,
        wxlogin,
    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main_edit_home {
    margin: 0;
    padding: 0;
}

.main_user_edit_content {
    margin: 0;
    padding: 0;
    margin-left: 5vw;
    margin-right: 5vw;
    margin-bottom: 0;
    margin-top: 30px;
}

.main_content > ul {
    margin: 0;
    padding: 0;
}

.edit_footer {
    display: block;
    width: 100%;
    height: 50px;
    margin: 0;
    padding: 0;
}

.edit_footer span {
    padding: 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    line-height: 50px;
}

</style>
